import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { SenaceService } from 'src/app/services/senace.service';

@Component({
  selector: 'app-valoracion-economica',
  templateUrl: './valoracion-economica.component.html',
  styleUrls: ['./valoracion-economica.component.css']
})
export class ValoracionEconomicaComponent implements OnInit {
  beneficioSocial: number;
  costoAmbiental: number;

  valoracionLista = {
    titulo: '',
    cabecera: ['Impacto', 'Ecosistema afectado', 'Método'],
    filas: []
  };

  constructor(
    private localStorage: LocalStorage,
    private senaceService: SenaceService
  ) {
    this.localStorage.getItem('detalle').subscribe(
      (resp: any[]) => {
        let datos = this.senaceService.getValoracionEconomica(resp);
        this.getListaValoracionEconomica(datos);
      }
    )
  }

  ngOnInit() {
  }

  getListaValoracionEconomica(resultado) {
    this.beneficioSocial = resultado['beneficioSocial'];
    this.costoAmbiental = resultado['costoAmbiental'];
    let data: any[] = resultado['valoracionEconomica'];
    data.forEach(item => {
      let arr = [item.impacto || '', item.ecosistemaAfectado || '', item.metodo || ''];
      this.valoracionLista.filas.push(...[arr]);
    });
  }

}
